"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledResizerBase = exports.StyledResizer = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireDefault(require("react"));
var _formInputTheme = require("../../textinput/styled/formInputTheme");
var _textAreaTheme = require("../textAreaTheme");
const StyledResizerBase = (0, _styled.default)("div")(_ref => {
  let {
    themeMode,
    isFocused,
    focusMode,
    validationState
  } = _ref;
  return `
    color: ${_textAreaTheme.textAreaTheme.resizerColor(themeMode)};
    position: absolute;
    bottom: ${_textAreaTheme.textAreaTheme.resizerOffset.bottom[(0, _formInputTheme.getStylingState)({
    validationState,
    isFocused,
    focusMode
  })](themeMode)};
    right: ${_textAreaTheme.textAreaTheme.resizerOffset.right[(0, _formInputTheme.getStylingState)({
    validationState,
    isFocused,
    focusMode
  })](themeMode)};
    z-index: 1;

    // necessary to keep the resizer sizing consistent even
    // if overriding styles are provided
    font-size: 13px;
    line-height: 18px;

    &:hover {
        cursor: ns-resize;
    }
`;
});
exports.StyledResizerBase = StyledResizerBase;
const StyledResizer = props => {
  return /*#__PURE__*/_react.default.createElement(StyledResizerBase, props, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "8",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.655 1.053a.5.5 0 1 0-.707-.707L.346 6.948a.5.5 0 1 0 .707.707l6.602-6.602Zm0 3.772a.5.5 0 0 0-.708-.707l-2.83 2.829a.5.5 0 0 0 .708.707l2.83-2.83Z",
    clipRule: "evenodd"
  })));
};
exports.StyledResizer = StyledResizer;
//# sourceMappingURL=StyledResizer.js.map